export enum firestoreCollections {
    config = 'config',
    users = 'users',
    projects = 'projects',
    sites = 'sites',
    buildings = 'buildings',
}